<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title">THE CECILS</h1>
<h1 class="titlea">THE DYNASTY AND LEGACY OF LORD BURGHLEY</h1>
<p class="author">DAVID LEE</p>
<div class="image_containerf">
<img alt="images" src="images/logo.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?79052ad7